import { Component, OnInit, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";

import {LocaleService} from "../../../../locale/locale.service";
import {ClaimsService} from "../../../../services/claims.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {TextAreaComponent} from "../../../common/text-area/text-area.component";

@Component({
  selector: 'app-detail-accident-description',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    TextAreaComponent
],
  templateUrl: './detail-accident-description.component.html',
  styleUrl: './detail-accident-description.component.css'
})
export class DetailAccidentDescriptionComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  claimService = inject(ClaimsService);

  public accidentDetailDescription: string | null = null;
  public showError: boolean = false;

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService?.claimReport()?.detailedDescription) {
        this.accidentDetailDescription = this.claimService.claimReport().detailedDescription;
      }
    })
  }

  private evaluateShowError() {
    this.showError = this.accidentDetailDescription === null;
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({detailedDescription: this.accidentDetailDescription});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['detail-accident-description']);
      });
    }
  }
}
